import React, { useContext, useEffect, useState } from "react";
import styles from "./styles/Search.module.css";
import DataContext from "../../context/DataContext";
import OutputWindowPayment from "../../components/ui/output_window_payment/OutputWindowPayment";
import Button from "../../components/ui/button/Button";
import PaymentForm from "./PaymentForm";

import {
    decryptor,
    calculatePayValues,
    capitalizeFirstLetter,
} from "../../utils/utils";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import useCurrencySymbol from "../../hooks/useCurrencySymbol";
import { axiosSC, axiosSW2 } from "../../api/axiosDefaults";
import { useTranslation } from "react-i18next";
import NavButton from "../../components/ui/navbutton/NavButton";
import LicencePlate from "../../components/ui/licence_plate/LicencePlate";
import useNumberFormat from "../../hooks/useNumberFormat";
import ButtonPopup from "../../components/ui/button_popup/ButtonPopup";
import PlatePanel from "./PlatePanel";

/**
 * Payment component
 * This component handles the initiating of the payment process using Stripe.
 */
const PaymentFloat = ({
    feeDetails, // {Object} - Fee details for the client.
    selectedTickets, // {Array} - Selected tickets array of objects.
    selectedInstalments,
    plateNumber, // {String} - Plate number.
}) => {
    const { t, i18n } = useTranslation();
    const {
        currentCustom, // {Object} - Current client customizations.
        connection, // {Object} - Current client's settings.
        handleError, // {Function} - Error handling function.
        responseData,
        ticketType,
        homePath,
        isPayHover,
        setIsPayHover,
        showPaymentForm,
        setShowPaymentForm,
    } = useContext(DataContext);
    const [clientSecret, setClientSecret] = useState("");
    const [stripePromise, setStripePromise] = useState(null);
    const [iscreatingIntent, setIscreatingIntent] = useState(false);

    const [paymentIntentID, setPaymentIntentID] = useState("");
    const [sumPayment, setSumPayment] = useState({
        administrative: 0,
        amount: 0,
    });
    const [payDisable, setPayDisable] = useState(true);
    // intKey is unique for each client and is used to decrypt the public key
    // const intKey = connection?.intKey;

    useEffect(() => {
        const allPayments = calculatePayValues(
            selectedTickets,
            selectedInstalments,
            feeDetails,
        );

        setSumPayment(allPayments);
    }, [selectedTickets, selectedInstalments]);

    // useEffect(() => {
    //     const TicketsPayment = calculatePayValues(selectedTickets, feeDetails);
    //     const instalmentsPayment = calculatePayValues(
    //         selectedInstalments,
    //         feeDetails
    //     );

    //     setSumPayment({
    //         administrative:
    //             selectedTickets.length || selectedInstalments.length
    //                 ? feeDetails?.fixedCosts +
    //                   TicketsPayment?.percent +
    //                   instalmentsPayment?.percent
    //                 : 0,
    //         amount: TicketsPayment?.amount + instalmentsPayment?.amount,
    //     });
    // }, [selectedTickets, selectedInstalments]);

    // useEffect(() => {
    //     if (connection?.publicKey) {
    //         try {
    //             const stripeKey = decryptor(connection.publicKey, intKey);
    //             // const stripeKey = decryptor(connection.publicKey, key, iv);
    //             setStripePromise(loadStripe(stripeKey));
    //         } catch (error) {
    //             console.error("Error initializing Stripe:", error);
    //         }
    //     }
    // }, [connection, intKey]);

    // Disable pay button if no tickets are selected
    useEffect(() => {
        setPayDisable(
            selectedTickets?.length || selectedInstalments.length
                ? false
                : true,
        );
    }, [selectedTickets, selectedInstalments]);

    /**
     * Return an array of the selected tickets numbers
     * @returns {Array} - Array of the tickets numbers.
     */
    const getTicketsNumbers = () => {
        return selectedTickets?.map((ticket) => ticket?.ticketNumber);
    };

    const getInstalmentsId = () => {
        return selectedInstalments.map(
            (instalment) => instalment?.instalmentId,
        );
    };

    /**
     * Return a description string
     * @returns {String} - Description string.
     */
    const getDescription = () => {
        var discreptionTickets = [];
        var discreptionInstalments = [];

        selectedTickets.map((ticket, idx) => {
            idx === 0
                ? (discreptionTickets = [
                      plateNumber,
                      `{${ticket?.ticketNumber} | ${ticket?.ticketDate.slice(
                          0,
                          ticket?.ticketDate.indexOf("T"),
                      )}}`,
                  ])
                : (discreptionTickets = [
                      ...discreptionTickets,
                      `{${ticket?.ticketNumber} | ${ticket?.ticketDate.slice(
                          0,
                          ticket?.ticketDate.indexOf("T"),
                      )}}`,
                  ]);
        });
        selectedInstalments.map((instalment, idx) => {
            idx === 0
                ? (discreptionInstalments = [
                      plateNumber,
                      `{${
                          instalment?.instalmentInfo
                      } | ${instalment?.instalmentDate.slice(
                          0,
                          instalment?.instalmentDate.indexOf("T"),
                      )}}`,
                  ])
                : (discreptionInstalments = [
                      ...discreptionInstalments,
                      `{${
                          instalment?.instalmentInfo
                      } | ${instalment?.instalmentDate.slice(
                          0,
                          instalment?.instalmentDate.indexOf("T"),
                      )}}`,
                  ]);
        });
        const discreptionTicketsString = discreptionTickets.join(" | ");
        const tempDiscreptionInstalmentsString =
            discreptionInstalments.join(" | ");
        const indexInstalmentDiv =
            tempDiscreptionInstalmentsString.indexOf("|");
        const discreptionInstalmentsString = discreptionTicketsString
            ? indexInstalmentDiv !== -1
                ? tempDiscreptionInstalmentsString.slice(indexInstalmentDiv + 1)
                : ""
            : tempDiscreptionInstalmentsString;

        return `${discreptionTicketsString} ${
            discreptionTicketsString && discreptionInstalmentsString
                ? "<||>"
                : ""
        } ${discreptionInstalmentsString}`;
    };

    /**
     * Return meta data object from selectedTickets for user feedback
     * @returns {Object} - Meta data object.
     */
    const getMetaData = () => {
        var metaData = {
            plateNumber: plateNumber,
            uniqueID: connection?.uniqueId,
        };
        var index = 0;
        selectedTickets.map((ticket, idx) => {
            metaData = {
                ...metaData,
                [`(${idx + 1})issueDate`]: ticket?.ticketDate.slice(
                    0,
                    ticket?.ticketDate.indexOf("T"),
                ),
                [`(${idx + 1})offences`]: ticket?.offences
                    .map((offence) => offence?.text)
                    .join(" | "),
                [`(${idx + 1})ticketNumber`]: ticket?.ticketNumber,
            };
            index = idx + 1;
        });
        selectedInstalments.map((instalment, idx) => {
            const currentIndex = index ? index : idx;
            metaData = {
                ...metaData,
                [`(${currentIndex + 1})dueDate`]:
                    instalment?.instalmentDate.slice(
                        0,
                        instalment?.instalmentDate.indexOf("T"),
                    ),
                [`(${currentIndex + 1})instalment`]: instalment?.instalmentInfo,
                [`(${currentIndex + 1})instalmentId`]: instalment?.instalmentId,
            };
            index = currentIndex + 1;
        });
        return metaData;
    };

    /**
     * Return window contant object
     * The amount and total amount to pay
     * @returns {Object} - Window content object.
     */
    const getWindowContent = () => {
        var windowContent = {
            plateNumber: plateNumber,
            tickets: [],
            instalments: [],
            administrative: sumPayment?.administrative,
            amount: sumPayment?.amount,
        };
        selectedTickets?.map((ticket) => {
            windowContent.tickets = [
                ...windowContent.tickets,
                {
                    ticketNumber: ticket.ticketNumber,
                    ticketDate: ticket.ticketDate,
                    amount: ticket.amount,
                },
            ];
        });
        selectedInstalments?.map((instalment) => {
            windowContent.instalments = [
                ...windowContent.instalments,
                {
                    instalmentInfo: instalment.instalmentInfo.split("#")[1],
                    instalmentDate: instalment.instalmentDate,
                    amount: instalment.amount,
                },
            ];
        });

        return windowContent;
    };

    /**
     * Create stripe intent
     * Through SW2
     * axiosSW2
     */
    const createPaymentIntent = async () => {
        setIscreatingIntent(true);
        try {
            const response = await axiosSW2.post("payments/reserve", {
                customerId: connection?.uniqueId,
                ticketNumbers: getTicketsNumbers(),
                chargeIds: getInstalmentsId(),
                ticketAmount: (sumPayment?.amount)
                    // + sumPayment?.administrative
                    .toFixed(0),
                description: getDescription(),
                // metadata: getMetaData(),
                currency: connection?.currencyCode,
                // intKey: connection?.intKey,
                // secretKey: connection?.secretKey,
                useStripeConnect: true,
            });
            setClientSecret(response?.data?.clientSecret);
            setPaymentIntentID(response?.data?.paymentIntentId);
            setStripePromise(loadStripe(response?.data?.publishableKey));
            setIscreatingIntent(false);
        } catch (error) {
            setIscreatingIntent(false);
            handleError(error);
            console.error("Error creating payment intent:", error);
        }
    };

    /**
     * Submit handle for pay
     */
    const handlePay = () => {
        if (!payDisable && !iscreatingIntent && !showPaymentForm) {
            createPaymentIntent();
            setShowPaymentForm(true);
        }
    };

    // The appearance object for stripe
    const appearance = {
        theme: "flat",
        variables: {
            colorPrimary: currentCustom?.color?.current,
            fontFamily: ' "Robota", sans-serif',
            fontLineHeight: "1.5",
            borderRadius: "10px",
            colorBackground: "#FFFFFF",
            accessibleColorOnColorPrimary: "#262626",
        },
        rules: {
            ".Block": {
                backgroundColor: "var(--colorBackground)",
                boxShadow: "none",
                padding: "12px",
            },
            ".Input": {
                padding: "12px",
            },
            ".Input:disabled, .Input--invalid:disabled": {
                color: "lightgray",
            },

            ".Label": {
                fontWeight: "500",
            },
        },
    };

    // const testtickets = [
    //     {
    //         ticketNumber: "DZ685279",
    //         amount: "50",
    //         ticketDate: "2025-08-21T12:28:00",
    //         offences: [
    //             {
    //                 code: "50",
    //                 text: "EXPIRED PARKING FIELD METER",
    //                 detailA: "PHOTO TAKEN OF VIOLATION",
    //                 detailB: null,
    //                 detailC: null,
    //                 amount: 35,
    //             },
    //         ],
    //     },
    // ];
    // const testFees = {
    //     fixedCosts: 0.19,
    //     percentageCosts: 0.06,
    // };

    return (
        <>
            {/* {console.log(calculatePayValues(testtickets, [], testFees))} */}
            {showPaymentForm && (
                // {showPaymentForm && clientSecret && (
                <div className={` ${styles.pay_form_back}  v-flex-container`}>
                    <Elements
                        stripe={stripePromise}
                        options={{
                            clientSecret,
                            appearance,
                            loader: "never",
                            locale: i18n.language,
                        }}
                        key={clientSecret}
                    >
                        <PaymentForm
                            administrative={sumPayment?.administrative}
                            paymentIntentID={paymentIntentID}
                            clientSecret={clientSecret}
                            windowContent={getWindowContent()}
                            totalAmount={
                                sumPayment?.amount + sumPayment?.administrative
                            }
                            description={getDescription()}
                            setShowPaymentForm={setShowPaymentForm}
                            showPaymentForm={showPaymentForm}
                            uniqueID={connection?.uniqueId}
                            ticketsNumbers={getTicketsNumbers()}
                            instalmentsId={getInstalmentsId()}
                        />
                    </Elements>
                </div>
            )}
            <div className={`v-flex-container`}>
                <div
                    className={` ${styles.popup_container} ${
                        !payDisable ? styles.popup_fade_in : ""
                    }  flex-container`}
                >
                    <p className={` ${styles.popup}`}>
                        {capitalizeFirstLetter(
                            t("please verify that all information is correct"),
                        )}
                    </p>
                </div>
                <section
                    className={`${styles.main_payment_float_container} flex-container`}
                >
                    <div
                        className={`${styles.main_float_button_plate_container} v-flex-container`}
                    >
                        <PlatePanel responseData={responseData} />
                        {/* <div
                            className={`${styles.float_search_button_container} v-flex-container`}
                        >
                            <NavButton
                                body={t(`new search`)}
                                size={"adapt"}
                                link={homePath}
                            />
                        </div>
                        <div
                            className={`${styles.float_plate_container} flex-container`}
                        >
                            <LicencePlate
                                // margin={"1rem 0 0 0 "}
                                // country={"D"}
                                number={
                                    responseData?.ticket?.plate
                                        ? responseData?.ticket?.plate
                                        : responseData?.settlements?.[0]?.plate
                                          ? responseData?.settlements?.[0]
                                                ?.plate
                                          : responseData?.relatedTickets?.[0]
                                                ?.plate
                                }
                            />
                        </div> */}
                    </div>
                    <div
                        className={`${styles.main_float_payment_window_container} v-flex-container`}
                    >
                        {/* {isPayHover && !payDisable ? ( */}
                        {/* <div
                        className={` ${styles.popup_container} ${
                            isPayHover && !payDisable
                                ? styles.popup_fade_in
                                : ""
                        }`}
                    >
                        <p className={` ${styles.popup}`}>
                            {capitalizeFirstLetter(
                                t(
                                    "please verify that all information is correct.",
                                ),
                            )}
                        </p>
                    </div> */}
                        {/* ) : (
                        <></>
                    )} */}
                        <div
                            className={`${styles.float_payment_window_container} flex-container`}
                        >
                            <OutputWindowPayment
                                amount={sumPayment?.amount}
                                administrative={sumPayment?.administrative}
                                currency={useCurrencySymbol()}
                            />

                            <div
                                className={`${styles.payment_float_button_container} flex-container`}
                            >
                                <ButtonPopup
                                    body={t(`pay`)}
                                    type={"button"}
                                    lightFontColor={true}
                                    color={"green"}
                                    setHoverFlag={setIsPayHover}
                                    onClickFuction={handlePay}
                                    disabled={payDisable}
                                    garyDisabled={payDisable}
                                    popup={t("choose a ticket")}
                                />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default PaymentFloat;
